(function() {

  'use strict';

  function ShippingConfig($q, ShippingConfigResource) {
    var ShippingConfig = {};

    ShippingConfig.getOptions = function(callback) {

      var cb = callback || angular.noop;
      var deferred = $q.defer();

      ShippingConfigResource.getOptions()
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;

    };

    return ShippingConfig;
  }

  angular
    .module('mandaeApp')
    .factory('ShippingConfig', ShippingConfig);

}());
